import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { MatDivider } from '@angular/material/divider'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatListModule } from '@angular/material/list'
import { ReasonService } from '../../../core/services/reason/reason/reason.service'
import { TelefonePipe } from '../../../shared/pipes/phone.pipes'

@Component({
  selector: 'modal-cancel-proposal',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDivider,
    MatProgressBar,
    MatListModule,
    TelefonePipe,
  ],
  templateUrl: './modal-cancel-proposal.component.html',
  styleUrl: './modal-cancel-proposal.component.scss',
  providers: [ProposalClientService],
  standalone: true,
})
export class ModalCancelProposalComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private reasonService: ReasonService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalCancelProposalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private dialog: MatDialog,
  ) {
    if (data.item) {
      this.item = data.item
    }
  }

  @Output() responseDelete = new EventEmitter()
  form: FormGroup = new FormGroup({})
  item: any = {}
  listReason: any[] = []
  listCancel: any[] = [
    { value: 5, description: 'Reprovado' },
    { value: 6, description: 'Cancelado' },
  ]
  loading = false

  ngOnInit(): void {
    this.getReasonsList()
    // this.listReason =
    //   { id: 1, descricao: 'Fechou com o concorrente' },
    //   { id: 2, descricao: 'Não deu retorno' },
    //   { id: 3, descricao: 'Evento cancelado' },
    //   { id: 4, descricao: 'Agência perdeu a concorrência' },
    //   { id: 5, descricao: 'Não informou o motivo' },
    //   { id: 6, descricao: 'Evento adiado sem data prevista' },
    //   { id: 7, descricao: 'Valores' },
    //   { id: 8, descricao: 'Carro próprio/ Terceiros' },
    //   { id: 9, descricao: 'Evento sem transfer' }
    // ]
    this.createForm()
  }

  createForm() {
    this.form = this.formBuilder.group({
      cancelSelected: [6],
      reasonSelected: [''],
    })
    this.form.get('reasonSelected')?.disable()
  }

  onSelectionCancel(event: MatSelectChange) {
    if (event.value == 5) {
      this.form.get('reasonSelected')!.setValidators(Validators.required)
      this.form.get('reasonSelected')!.enable()
    } else {
      this.form.get('reasonSelected')!.clearValidators()
      this.form.get('reasonSelected')!.disable()
    }
  }

  getReasonsList() {
    this.listReason = []
    this.reasonService.listReason().subscribe({
      next: (response: any) => {
        this.listReason = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  close() {
    this.dialogRef.close()
  }

  cancelProposalClient() {
    this.loading = true
    const status = this.form.get('cancelSelected')?.value
    if (status == 5 || status == 6) {
      this.proposalClientService
        .cancelProposalClient(this.createModel(status))
        .subscribe({
          next: (response: any) => {
            this.snackbar.success(response.message)
            this.responseDelete.emit(true)
            this.close()
            this.loading = false
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
            this.snackbar.errorRequest(err)
            this.loading = false
          },
          complete: () => {
            this.loading = false
          },
        })
    } else {
      this.snackbar.info('Necessário selecionar cancelado ou reprovado.')
      this.loading = false
    }
  }

  createModel(status: any) {
    // Reprovado
    if (status == 5) {
      return {
        propostaId: this.item.id,
        statusProposta: status,
        motivoId: this.form.get('reasonSelected')?.value,
      }
    }
    // Cancelado
    else if (status == 6) {
      return {
        propostaId: this.item.id,
        statusProposta: status,
        motivoId: 0,
      }
    } else {
      return {}
    }

    // let motivo = 0
    // if (this.form.get('cancelSelected')?.value == 5) {
    //   motivo = this.form.get('reasonSelected')?.value
    // } else {
    //   motivo = 0
    // }
    // return {
    //   propostaId: this.item.id,
    //   statusProposta: this.form.get('cancelSelected')?.value,
    //   motivoId: motivo,
    // }
  }
}
